import { Env } from "@mmh/types"
import { FirebaseOptions } from "firebase/app"

export const apiBaseUrl = import.meta.env.PUBLIC_API_BASE_URL || `http://${window.location.hostname}:4000`

export const env = import.meta.env.PUBLIC_ENV as Env || "dev"

// const websiteUrl = {
//     dev: "https://d3fb7bpj2zxit.cloudfront.net",
//     prod: "https://ospi.com"
// }[env]

export const firebaseOptions: FirebaseOptions = {
    dev: {
        apiKey: "fake-key",
        projectId: "demo-no-project",
        appId: "1:123456789012:web:fake123456789",
        measurementId: "G-FAKEVALUE123",
        authDomain: "demo-no-project.firebaseapp.com",
        messagingSenderId: "123456789012",
        storageBucket: "demo-no-project.appspot.com"
    },
    prod: {
        apiKey: "AIzaSyBq-x6HACq4cmLhcgeQc11HebyySAgFy-A",
        authDomain: "mmh-co.firebaseapp.com",
        projectId: "mmh-co",
        storageBucket: "mmh-co.firebasestorage.app",
        messagingSenderId: "805362960471",
        appId: "1:805362960471:web:a5d19d7920b5eccceb7b12",
        measurementId: "G-XLJKG3395R"
    }
}[env]

export const restaurantShim = {
    name: "ospi",
    website: "https://ospi.com",
    cuisine: "Italian",
    parentCompany: {
        name: "Memento Mori Hospitality Group",
        dba: "Memento Mori Hospitality",
        address: "241 Main Street, El Segundo, CA 90245",
        email: "hello@mmh.co",
        phone: "(310) 648-8554",
        jurisdiction: "Los Angeles, County of Los Angeles, California",
        website: "https://mmh.co"
    },
    images: {
        logo: "/global/logo.svg",
        wordmark: "/global/wordmark.svg",
        footerLogo: "/global/footer-logo.svg"
    },
    disabledDates: {
        inquiry: [{ month: 2, day: 14 }],
        reservation: []
    },
    external: {
        mux: {
            src: "https://cdn.jsdelivr.net/npm/@mux/mux-video",
            playbackId: "IFA1kr5bvgljXwKhL7V3jHtv1CyFnVYMT7nZA6vFC00M",
            metadataVideoTitle: "hero-original",
            poster: "https://image.mux.com/IFA1kr5bvgljXwKhL7V3jHtv1CyFnVYMT7nZA6vFC00M/thumbnail.webp?width=6424&height=1936&time=0"
        },
        careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199bc29eca73f71"
    },
    merch: {
        title: "The Merch Shop",
        paragraphs: [
            "<em>For those who order the Spicy Rigatoni every time.</em><br/><em>For those who ask for extra vodka sauce.</em><br/><em>For those who don't even need to look at the menu anymore.</em><br/><br/>We figured it was time to make something you could take home besides leftovers.",
            "Inspired by the dishes, restaurants, and people that have made MMH what it is, our first collection features premium everyday essentials designed to carry the MMH lifestyle beyond the table. Thoughtfully crafted with timeless fits and quality materials.",
            "Designed to be collected, not reproduced, each release is produced in limited quantities and available only once. Think of it like your favorite special: here for a good time, not forever."
        ],
        buttonText: "Shop Now",
        url: "https://shop.mmh.co/",
        imageAlt: "MMH Collection merch"
    },
    locations: [
        {
            path: "brentwood",
            image: "/concept/brentwood.jpg",
            tagline: "Italian Restaurant in Brentwood, CA",
            metaDescription: "Modern Italian in Brentwood — handmade pasta, pizza romana tonda, and weekend spritzes. Book for special occasions, business dinners, and private events.",
            searchPlace: "Brentwood, CA",
            spaces: [
                {
                    src: "/brentwood/page-content/private-dining/patio.jpg",
                    alt: "Outdoor Patio at Ospi",
                    title: "Outdoor Patio",
                    policy: "Partial Buyout",
                    description: "The outdoor patio is available for a buyout fee for up to 45 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                },
                {
                    src: "/brentwood/page-content/hero/hero.jpg",
                    alt: "Main Dining Room at Ospi Brentwood",
                    title: "Main Dining Room",
                    policy: "Full Buyout",
                    description: "The main dining room is available for a full buyout for up to 100 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                }
            ],
            pageContent: {
                hero: {
                    visible: true,
                    image: "/brentwood/page-content/hero/hero.jpg",
                    wordmark: "/brentwood/page-content/hero/wordmark.svg",
                    alt: "Ospi Brentwood main dining room"
                },
                gallery: [
                    { path: "/brentwood/page-content/gallery/sign-thumb.jpg", alt: "Ospi Brentwood sign.", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/spritz-cart-thumb.jpg", alt: "A spritz cart full of drink ingredients and vases full of flowers against a salmon-colored wall.", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/restaurant-thumb.jpg", alt: "The interior of Ospi Brentwood.", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/martini-thumb.jpeg", alt: "Martini cocktail presentation.", class: "col-span-1 row-span-3" },
                    { path: "/brentwood/page-content/gallery/interior-thumb.png", alt: "Brentwood restaurant interior view", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/kale-salad-thumb.jpeg", alt: "A bowl of kale salad.", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/spicy-rigatoni-thumb.jpg", alt: "Spicy rigatoni pasta dish.", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/cannoli-thumb.jpg", alt: "Three cannoli desserts on a plate", class: "col-span-1 row-span-1" },
                    { path: "/brentwood/page-content/gallery/patio-thumb.jpg", alt: "The outdoor patio at Ospi Brentwood.", class: "col-span-2 row-span-1" }
                ]
            },
            external: {
                api: {
                    hubspot: {
                        formId: "a61fe7d2-703e-4183-aebb-acc8eda350cb",
                        portalId: "22788501"
                    },
                    openTable: {
                        url: "https://www.opentable.com/r/ospi-brentwood-los-angeles"
                    }
                },
                url: {
                    onlineOrdering: "https://order.toasttab.com/online/ospi-brentwood",
                    giftCard: "https://www.toasttab.com/ospi-brentwood/giftcards",
                    loyaltyRewards: "https://www.toasttab.com/ospi-brentwood/rewardsSignup",
                    careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199c0184fe34242",
                    onlineOrderingCatering: "https://order.toasttab.com/online/ospi-brentwood"
                }
            }
        },
        {
            path: "costamesa",
            image: "/concept/costamesa.jpg",
            tagline: "Italian Restaurant in Costa Mesa, CA",
            metaDescription: "Southern Italian coastal California — house-made pasta, romana tonda pizza, and curated wine in Costa Mesa. Ideal for special occasions and business dinners.",
            spaces: [
                {
                    src: "/costamesa/page-content/private-dining/main-dining-room.jpg",
                    alt: "Main Dining Room at Ospi Costa Mesa",
                    title: "Main Dining Room",
                    policy: "Full Buyout",
                    description: "The main dining room is available for a full buyout for up to 100 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                },
                {
                    src: "/costamesa/page-content/private-dining/patio.jpg",
                    alt: "Outdoor Patio at Ospi",
                    title: "Outdoor Patio",
                    policy: "Partial Buyout",
                    description: "The outdoor patio is available for a buyout fee for up to 48 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                }
            ],
            pageContent: {
                hero: {
                    visible: true,
                    image: "/costamesa/page-content/hero/hero.jpg",
                    wordmark: "/costamesa/page-content/hero/wordmark.svg",
                    alt: "The bar at Ospi Costa Mesa"
                },
                gallery: [
                    { path: "/costamesa/page-content/gallery/pizza-boxes-thumb.jpg", alt: "A stack of pizza boxes.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/kale-salad.jpg", alt: "A plate of kale salad.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/food-assortment.jpg", alt: "Assortment of Ospi entrées.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/ospi-sign.jpg", alt: "Exterior Ospi sign at Costa Mesa.", class: "col-span-1 row-span-3" },
                    { path: "/costamesa/page-content/gallery/bar-thumb.jpg", alt: "The bar at Ospi Costa Mesa.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/vodka-pizza-thumb.jpg", alt: "A vodka pizza with chunks of mozzarella.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/spritz-assortment.jpg", alt: "Assortment of spritz glasses.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/spicy-rigatoni-thumb.jpg", alt: "Spicy rigatoni pasta dish.", class: "col-span-1 row-span-1" },
                    { path: "/costamesa/page-content/gallery/interior-thumb.jpg", alt: "Costa Mesa restaurant interior view", class: "col-span-2 row-span-1" }
                ]
            },
            external: {
                api: {
                    hubspot: {
                        formId: "6e4678ca-bb2e-4d45-aefd-dc84a8e71e92",
                        portalId: "22788501"
                    },
                    openTable: {
                        url: "https://www.opentable.com/r/ospi-costa-mesa-reservations-costa-mesa?restref=1381024&lang=en-US&ot_source=Restaurant%20website"
                    }
                },
                url: {
                    onlineOrdering: "https://order.toasttab.com/online/ospi-costa-mesa",
                    giftCard: "https://www.toasttab.com/ospi-costa-mesa/giftcards",
                    loyaltyRewards: "https://www.toasttab.com/ospi-costa-mesa/rewardsSignup",
                    careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199bc29eca73f71",
                    onlineOrderingCatering: "https://order.toasttab.com/online/ospi-costa-mesa"
                }
            }
        },
        {
            path: "dallas",
            image: "/concept/dallas.jpg",
            tagline: "Italian Restaurant in Dallas, TX",
            metaDescription: "Modern Southern-Italian in the Dallas Design District — handmade pasta, romana tonda pizza, brunch. Book for special occasions and business dinners.",
            spaces: [
                {
                    src: "/dallas/page-content/private-dining/pasta-room.jpg",
                    title: "Pasta Dining Room (Semi-Private)",
                    policy: "Partial Buyout",
                    description: "Semi-private indoor dining room accommodates up to 28 guests.",
                    maxGuests: 28,
                    minGuests: 9,
                    price: "Contact for pricing"
                },
                {
                    src: "/dallas/page-content/private-dining/patio.jpg",
                    title: "Enclosed Outdoor Patio",
                    policy: "Room Fee",
                    description: "Our enclosed outdoor patio offers an exclusive al fresco experience for up to 40 guests.",
                    maxGuests: 40,
                    minGuests: 15,
                    price: "Contact for pricing"
                },
                {
                    src: "/dallas/page-content/private-dining/main-dining-room.jpg",
                    title: "Main Dining Room (Semi-Private)",
                    policy: "Partial Buyout",
                    description: "Semi-private section of the main dining room that accommodates up to 50 guests.",
                    maxGuests: 50,
                    minGuests: 20,
                    price: "Contact for pricing"
                }
            ],
            pageContent: {
                hero: {
                    visible: true,
                    image: "/dallas/page-content/hero/hero.jpg",
                    wordmark: "/dallas/page-content/hero/wordmark.svg",
                    alt: "Pasta being handmade"
                },
                gallery: [
                    { path: "/dallas/page-content/gallery/brunch-assortment.jpg", alt: "Brunch assortment", class: "col-span-1 sm:col-span-1 row-span-1 sm:row-span-3" },
                    { path: "/dallas/page-content/gallery/raschiatelli.jpg", alt: "Raschiatelli pasta", class: "col-span-1 row-span-1" },
                    { path: "/dallas/page-content/gallery/spicy-rigatoni.jpg", alt: "Spicy rigatoni", class: "col-span-1 row-span-1" },
                    { path: "/dallas/page-content/gallery/espresso-martini.jpg", alt: "Espresso martini", class: "col-span-1 row-span-1" },
                    { path: "/dallas/page-content/gallery/kale-salad.jpg", alt: "Kale salad", class: "col-span-1 row-span-1" },
                    { path: "/dallas/page-content/gallery/vodka-pizza.jpg", alt: "Vodka pizza", class: "col-span-1 row-span-1" },
                    { path: "/dallas/page-content/gallery/food-assortment.jpg", alt: "Ospi Dallas entrée food assortment", class: "col-span-1 sm:col-span-1 row-span-1 sm:row-span-2" },
                    { path: "/dallas/page-content/gallery/crispy-provolone.jpeg", alt: "Crispy provolone", class: "col-span-1 sm:col-span-2 row-span-1" }
                ]
            },
            external: {
                api: {
                    hubspot: {
                        formId: "b68f5e8a-1bf6-467e-a85d-7b54f33618f7",
                        portalId: "22788501"
                    },
                    openTable: {
                        url: "https://www.opentable.com/r/ospi-dallas"
                    }
                },
                url: {
                    onlineOrdering: "https://order.toasttab.com/online/ospi-dallas",
                    giftCard: "https://order.toasttab.com/egiftcards/ospi-dallas",
                    loyaltyRewards: "https://www.toasttab.com/ospi-dallas/rewardsSignup",
                    careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199bc29eca73f71",
                    onlineOrderingCatering: "https://order.toasttab.com/online/ospi-dallas"
                }
            }
        },
        {
            path: "montecito",
            image: "/concept/montecito.jpg",
            tagline: "Italian Restaurant in Montecito, CA",
            metaDescription: "Cal-Italian dining at The Post in Montecito — house-made pasta, wood-grilled seafood, and breakfast. Perfect for special occasions and business dinners.",
            searchPlace: "Montecito, CA",
            spaces: [
                {
                    src: "/montecito/page-content/private-dining/private-dining-room.jpg",
                    alt: "Private Room at Ospi",
                    title: "Private Room",
                    policy: "Room Fee",
                    description: "The Private Room is available for a room fee for up to 12 guests.",
                    maxGuests: 12,
                    minGuests: 8,
                    price: "$500"
                },
                {
                    src: "/montecito/page-content/private-dining/main-dining-room.jpg",
                    alt: "Main Dining Room at Ospi Montecito",
                    title: "Main Dining Room",
                    policy: "Full Buyout",
                    description: "The main dining room is available for a full buyout for up to 100 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                },
                {
                    src: "/montecito/page-content/private-dining/patio.jpg",
                    title: "Outdoor Patio",
                    policy: "Partial Buyout",
                    description: "The outdoor patio is available for a buyout fee for up to 48 guests.",
                    price: "Contact for pricing",
                    maxGuests: Infinity
                }
            ],
            pageContent: {
                hero: {
                    visible: true,
                    image: "/montecito/page-content/hero/hero.jpg",
                    wordmark: "/montecito/page-content/hero/wordmark.svg",
                    alt: "Ospi Montecito main dining room and bar"
                },
                gallery: [
                    { path: "/montecito/page-content/gallery/kale-salad-thumb.jpg", alt: "A bowl of kale salad.", class: "col-span-1 row-span-1" },
                    { path: "/montecito/page-content/gallery/vodka-pizza-thumb.jpg", alt: "A vodka pizza with chunks of mozzarella.", class: "col-span-1 row-span-1" },
                    { path: "/montecito/page-content/gallery/spicy-rigatoni-thumb.jpg", alt: "Spicy rigatoni pasta dish.", class: "col-span-1 row-span-1" },
                    { path: "/montecito/page-content/gallery/interior-bar-thumb.jpg", alt: "The bar at Ospi Montecito.", class: "col-span-1 row-span-3" },
                    { path: "/montecito/page-content/gallery/burrata-thumb.jpg", alt: "A plate of burrata cheese.", class: "col-span-1 row-span-2" },
                    { path: "/montecito/page-content/gallery/artichoke-thumb.jpg", alt: "A plate of artichoke.", class: "col-span-1 row-span-1" },
                    { path: "/montecito/page-content/gallery/ribs-thumb.jpg", alt: "A plate of ribs.", class: "col-span-1 row-span-1" },
                    { path: "/montecito/page-content/gallery/patio-thumb.jpg", alt: "The outdoor patio at Ospi Montecito.", class: "col-span-2 row-span-1" }
                ]
            },
            external: {
                api: {
                    hubspot: {
                        formId: "c8151ec9-45cc-4494-bfc4-fde170a1f650",
                        portalId: "22788501"
                    },
                    openTable: {
                        url: "https://www.opentable.com/r/ospi-montecito-santa-barbara"
                    }
                },
                url: {
                    onlineOrdering: "https://order.toasttab.com/online/ospi-montecito",
                    giftCard: "https://www.toasttab.com/ospi-montecito/giftcards",
                    loyaltyRewards: "https://www.toasttab.com/ospi-montecito/rewardsSignup",
                    careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199bfe742e841e8",
                    onlineOrderingCatering: "https://order.toasttab.com/online/ospi-montecito"
                }
            }
        },
        {
            path: "venice",
            image: "/concept/venice.png",
            tagline: "Italian Restaurant in Venice, CA",
            metaDescription: "Brooklyn red sauce with a Venice twist — handmade pasta, romana tonda pizza, weekend brunch. Book for special occasions, business dinners, and events.",
            spaces: [
                {
                    src: "/venice/page-content/private-dining/private-dining-room.jpg",
                    alt: "Private Dining Room at Ospi Venice",
                    title: "Private Dining Room",
                    policy: "Room Fee",
                    description: "Private Dining Room above the bar accommodates up to 16 guests.",
                    maxGuests: 16,
                    minGuests: 7,
                    price: "$500"
                },
                {
                    src: "/venice/page-content/private-dining/back-dining-room.jpg",
                    alt: "Back Dining Room at Ospi Venice",
                    title: "Back Dining Room",
                    policy: "Partial Buyout",
                    description: "Back Dining Room accommodates up to 55 guests.",
                    maxGuests: 55,
                    minGuests: 30,
                    price: "$1500"
                },
                {
                    src: "/venice/page-content/private-dining/main-dining-room.jpg",
                    alt: "Main Dining Room at Ospi Venice",
                    title: "Entire Restaurant",
                    policy: "Full Buyout",
                    description: "The entire restaurant is available for a full buyout for up to 100 guests.",
                    maxGuests: 175,
                    minGuests: 60,
                    price: "Contact for pricing"
                }
            ],
            pageContent: {
                hero: {
                    visible: true,
                    image: "/venice/page-content/hero/hero.jpg",
                    wordmark: "/venice/page-content/hero/wordmark.svg",
                    alt: "Chef preparing pasta in Ospi Venice kitchen"
                },
                gallery: [
                    { path: "/venice/page-content/gallery/feed-me-pasta-thumb.jpg", alt: "Pasta dish in front of San Marzano tomato cans and a neon sign that says \"& tell me I'm pretty\"", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/mural-thumb.jpeg", alt: "The mural at Ospi Venice", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/saka-thumb.jpg", alt: "Riccotta cheese appetizer on a plate", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/limoncello.jpg", alt: "Limoncello in martini glass", class: "col-span-1 row-span-3" },
                    { path: "/venice/page-content/gallery/pizza-thumb.jpg", alt: "Gourmet vodka pizza with fresh toppings", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/pasta-thumb.jpg", alt: "Pasta being prepared by a chef in a large metal pot", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/cocktails-thumb.jpg", alt: "Lineup of cocktails on a wooden surface", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/stracciatella-thumb.png", alt: "Savory stracciatella and pesto on toast with pine nuts", class: "col-span-1 row-span-1" },
                    { path: "/venice/page-content/gallery/interior-thumb.jpg", alt: "Ospi Venice restaurant interior view", class: "col-span-2 row-span-1" }
                ]
            },
            external: {
                api: {
                    hubspot: {
                        formId: "ef590134-0f2b-4eb9-84bc-288c4cbe7679",
                        portalId: "22788501"
                    },
                    openTable: {
                        url: "https://www.opentable.com/r/ospi-venice"
                    }
                },
                url: {
                    onlineOrdering: "https://order.toasttab.com/online/ospi-venice",
                    giftCard: "https://www.toasttab.com/ospi-venice/giftcards",
                    loyaltyRewards: "https://www.toasttab.com/ospi-venice/rewardsSignup",
                    careers: "https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c699734e1b0199bc36ea393fa6",
                    onlineOrderingCatering: "https://order.toasttab.com/online/ospi-venice"
                }
            }
        }
    ]
}